import { Routes } from '@angular/router';
import { CONSTANTS } from '@cue-admin/constants';
import { AccountDoesntExistGuard } from '@cue-admin/account-data';
import { AccountExistsGuard } from '@cue-admin/account-data';
import { BasicAuthenticationGuard } from '@cue-admin/account-data';
import { UserIsNotLoggedInGuard } from '@cue-admin/account-data';
import { LicenseNotExistGuard } from '@cue-admin/account-data';
import { OAuthCallbackGuard } from '@cue-admin/account-data';
import { ResetPasswordGuard } from '@cue-admin/account-data';
import { SetPinGuard } from '@cue-admin/account-data';

export const accountRoutes: Routes = [
  {
    path: 'account',
    loadComponent: () => import('./components/account/account.component').then((x: any) => x.AccountComponent),
    children: [
      {
        path: '',
        redirectTo: CONSTANTS.paths.accountLogin,
        pathMatch: 'full',
      },
      {
        path: CONSTANTS.paths.oauthCallback,
        loadComponent: () => import('./components/login/login.component').then((x: any) => x.LoginComponent),
        canActivate: [OAuthCallbackGuard],
      },
      {
        path: CONSTANTS.paths.accountLogin,
        loadComponent: () => import('./components/login/login.component').then((x: any) => x.LoginComponent),
        canActivate: [AccountExistsGuard, UserIsNotLoggedInGuard],
      },
      {
        path: CONSTANTS.paths.accountRegister,
        loadComponent: () => import('./components/register/register.component').then((x: any) => x.RegisterComponent),
        canActivate: [AccountDoesntExistGuard],
      },
      {
        path: CONSTANTS.paths.accountResetPassword,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./components/resetPassword/resetPassword.component').then((x: any) => x.ResetPasswordComponent),
            canActivate: [AccountExistsGuard, UserIsNotLoggedInGuard, ResetPasswordGuard, BasicAuthenticationGuard],
          },
          {
            path: ':token',
            loadComponent: () =>
              import('./components/resetPassword/resetPassword.component').then((x: any) => x.ResetPasswordComponent),
            canActivate: [AccountExistsGuard, UserIsNotLoggedInGuard, BasicAuthenticationGuard],
          },
        ],
      },
      {
        path: CONSTANTS.paths.accountForgottenPassword,
        loadComponent: () =>
          import('./components/forgottenPassword/forgottenPassword.component').then(
            (x: any) => x.ForgottenPasswordComponent
          ),
        canActivate: [AccountExistsGuard, UserIsNotLoggedInGuard, BasicAuthenticationGuard],
      },
      {
        path: CONSTANTS.paths.uploadCertificate,
        loadComponent: () =>
          import('./components/upload-certificate/upload-certificate.component').then(
            (x: any) => x.UploadCertificateComponent
          ),
        canActivate: [AccountExistsGuard, UserIsNotLoggedInGuard, LicenseNotExistGuard],
      },
      {
        path: CONSTANTS.paths.activateLicenseKey,
        loadComponent: () =>
          import('./components/activate-license-key/activate-license-key.component').then(
            (x: any) => x.ActivateLicenseKeyComponent
          ),
        canActivate: [AccountExistsGuard, UserIsNotLoggedInGuard, LicenseNotExistGuard],
      },
      {
        path: CONSTANTS.paths.forgottenPIN,
        loadComponent: () =>
          import('./components/forgotten-pin-code/forgotten-pin-code.component').then(
            (x: any) => x.ForgottenPinCodeComponent
          ),
        canActivate: [AccountExistsGuard, UserIsNotLoggedInGuard],
      },
      {
        path: CONSTANTS.paths.setPIN,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./components/set-pin-code/set-pin-code.component').then((x: any) => x.SetPinCodeComponent),
            canActivate: [AccountExistsGuard, UserIsNotLoggedInGuard, SetPinGuard],
          },
          {
            path: ':token',
            loadComponent: () =>
              import('./components/set-pin-code/set-pin-code.component').then((x: any) => x.SetPinCodeComponent),
            canActivate: [AccountExistsGuard, UserIsNotLoggedInGuard],
          },
        ],
      },
    ],
  },
];
